import * as React from 'react';
import { withRouter, Route, Switch, RouteComponentProps } from 'react-router-dom';

import { ErrorLogger } from './gs-core/client';

import { Subject } from './common/models';

interface RoutesProps extends RouteComponentProps<any> {
  routes: AppRoute[];
  errorLogger: ErrorLogger;
  onLoading: (loading: boolean) => void;
  onSubjectChange: (subject: Subject | undefined) => void;
  onShowSidebar: (showSidebar: boolean) => void;
}

interface RoutesState {
}

export interface AppRoute {
  path?: string;
  exact?: boolean;
  showSidebar?: boolean;
  component: React.ComponentType<any>;
}

let activeRoute: AppRoute;

class RoutesRendererComponent extends React.Component<RoutesProps, RoutesState> {
  constructor(props: RoutesProps) {
    super(props);
    this.state = {};
  }

  async componentDidUpdate(prevProps: RoutesProps) {
    if (prevProps.location !== this.props.location) {
      this.props.onShowSidebar(activeRoute.showSidebar === undefined ? true : activeRoute.showSidebar);
    }
  }

  componentDidMount() {
    this.props.onShowSidebar(activeRoute.showSidebar === undefined ? true : activeRoute.showSidebar);
  }

  render() {
    return (
      <Switch>
        {this.props.routes.map(route =>
          <Route
            key={'route'} // prevent url changes from refreshing the entire component tree
            exact={route.exact || false}
            path={route.path}
            render={props => {
              activeRoute = route;

              return (
                <route.component
                  onLoading={this.props.onLoading}
                  onSubjectChange={this.props.onSubjectChange}
                  history={props.history}
                  location={props.location}
                  {...props.match.params}
                />
              );
            }}
          />
        )}
      </Switch>
    );
  }
}

export const RoutesRenderer = withRouter(RoutesRendererComponent);



// WEBPACK FOOTER //
// ./src/RoutesRenderer.tsx